import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { FeaturesBento } from "@/components/FeaturesBento";
import { ManifestoChapters } from "@/components/ManifestoChapters";
import { AppPreviewSection } from "@/components/AppPreviewSection";
import { StoreBadgesSection } from "@/components/StoreBadgesSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash), 150);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <main data-testid="landing-page" className="relative">
      <Navbar />
      <HeroSection />
      <EditorialMarquee />
      <FeaturesBento />
      <ManifestoChapters />
      <AppPreviewSection />
      <EditorialMarquee />
      <StoreBadgesSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
